import React, { useState, useEffect } from 'react';

import { IComponentRadio } from '../../component.d';
import { RenderRequired } from './Form';

const AllForFormRadio = function(props: IComponentRadio) {
  const {
    field,
    align,
    width,
    onChange,
    required,
    select,
    label,
    type
  } = props;

  const [data, setData] = useState([] as string[]);

  return (
    <div className="all-for-input">
      <div className="weui-cells__group weui-cells__group_form">
        {label ? (
          <div className="weui-cells__title">
            {field} {RenderRequired(required)}
          </div>
        ) : null}
        <div className="weui-cells weui-cells_checkbox">
          {select.map((it: string, index: number) => {
            return (
              <label
                key={it + index}
                className="weui-cell weui-cell_active weui-check__label"
              >
                <div className="weui-cell__hd">
                  <input
                    type="checkbox"
                    readOnly={true}
                    className="weui-check"
                    name={field}
                    checked={!!data.find((str: string) => str == it)}
                    onClick={(e: any) => {
                      let newData = [...data].filter(Boolean) as string[];
                      if (newData.find((str: string) => str == it)) {
                        newData = newData.filter(
                          (str: string) => str != it
                        ) as string[];
                      } else {
                        newData.push(it);
                      }
                      setData(newData);
                      onChange(type, field, newData);
                    }}
                  />
                  <i className="weui-icon-checked"></i>
                </div>
                <div className="weui-cell__bd">
                  <p>{it}</p>
                </div>
              </label>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AllForFormRadio;
